import {
  Burger,
  Button,
  Center,
  Container,
  Group,
  Menu,
  useMantineTheme,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown } from "@tabler/icons-react";
import { Link } from "gatsby";
import React from "react";
import { ROUTES } from "../../constants/routes";
import { IconLogo } from "./IconLogo";
import { links } from "./data";
import * as classes from "./index.module.css";

export default function SiteHeader() {
  const theme = useMantineTheme();
  const [opened, { toggle }] = useDisclosure(false);

  const items = links.map((link) => {
    const menuItems = link.links?.map((item) => (
      <Menu.Item
        component={Link}
        to={item.link}
        key={item.link}
        className={classes.item}
      >
        {item.label}
      </Menu.Item>
    ));

    if (menuItems) {
      return (
        <Menu
          key={link.label}
          trigger="click"
          transitionProps={{ exitDuration: 0 }}
          withinPortal
        >
          <Menu.Target>
            <Button
              className={classes.link}
              variant="transparent"
              color="brandBlack"
            >
              <Center>
                <span className={classes.linkLabel}>{link.label}</span>
                <IconChevronDown size="0.9rem" stroke={1.5} />
              </Center>
            </Button>
          </Menu.Target>
          <Menu.Dropdown>{menuItems}</Menu.Dropdown>
        </Menu>
      );
    }

    return (
      <Button
        component={Link}
        key={link.label}
        to={link.link}
        className={classes.link}
        variant="transparent"
        color="brandBlack"
        activeStyle={{ color: theme.colors.brandBlue[1] }}
        partiallyActive={link.partiallyActive}
      >
        {link.label}
      </Button>
    );
  });

  return (
    <header className={classes.header}>
      <Container size="lg">
        <div className={classes.inner}>
          <Link to={ROUTES.home}>
            <IconLogo />
          </Link>
          <Group gap={2} visibleFrom="lg">
            {items}
          </Group>
          <Button
            component={Link}
            to={ROUTES.enquiry}
            color="brandDarkBlue"
            radius="md"
            visibleFrom="lg"
          >
            Enquiry Now
          </Button>
          <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="lg" />
        </div>
      </Container>
    </header>
  );
}
